/*eslint-disable */
import { Button, Input, InputNumber } from "antd";
import React, { useEffect, useState } from "react";
import { DatePickerComponent } from "containers/backend/common/component/Index";
import classNames from "classnames";
import { DATE_TIME_FORMAT } from "constants/Define";
import moment from "moment";
import { getMomentDate } from "utils/commonUtils";

const InventoryMultiPlan = ({
  isCreate,
  isSubmit,
  startDate,
  endDate,
  onChangeDateRange,
}) => {
  const [inputValue, setInputValue] = useState(0);
  const [defaultDate, setDefaultDate] = useState([]);

  useEffect(() => {
    setDefaultDate([startDate, endDate]);
  }, [startDate, endDate]);

  useEffect(() => {
    if (isSubmit) {
      onChangeDateRange({
        inputValue,
        defaultDate,
      });
    }
  }, [isSubmit]);

  const onChangeField = (data) => {
    const date = data.value.map((d) =>
      getMomentDate(d, DATE_TIME_FORMAT.SHORT_DATE)
    );
    setDefaultDate(date);
  };
  const onInputChange = (e) => {
    const value = e.target.value;
    if (value == "") {
      setInputValue(0);
    } else setInputValue(value);
  };
  
  const disabledDate = (current) => {
    const dayStart = moment(startDate).startOf('day');;
    const dayEnd = moment(endDate).startOf('day').add(1, 'day');
    const currentDate = moment();
    if(!isCreate){
      if(dayStart > currentDate){
        return current < dayStart || current > dayEnd
      }
      return current <= currentDate || current > dayEnd
    }
    return current < dayStart || current > dayEnd
  };

  return (
    <div className="wrapper">
      <DatePickerComponent
        className={classNames("form-control applyDates w100-percent")}
        hmsComponent={`RangePicker`}
        style={{ padding: 0, borderWidth: 0 }}
        format={DATE_TIME_FORMAT.SHORT_DATE}
        name={`RangePicker`}
        disabledDate = {disabledDate}
        onChange={(e) => onChangeField(e)}
        value={defaultDate}
      />
      <div>
      <Input
        placeholder="1"
        type="number"
        min={0}
        style={{ marginTop : 10, width : "40%"}}
        onChange={(e) => onInputChange(e)}
        value={inputValue}
      />
      </div>
    </div>
  );
};

export default InventoryMultiPlan;